import DayPlanTrackings from "features/CenterContent/RoleContent/Personellstyrer/DayPlanTrackings/DayPlanTrackings";
import TrainMap from "features/CenterContent/RoleContent/TrainMap/TrainMap";
import { SharedContentGridLayout } from "features/CenterContent/shared/MainContentGrid";
import styled from "styled-components";

const Container = styled.div`
  ${SharedContentGridLayout};
  grid-template-rows: 11fr 5fr;
  overflow: auto;
`;

export const Personellstyrer = () => (
  <Container>
    <TrainMap />
    <DayPlanTrackings />
  </Container>
);
